import React, { useState, useEffect } from 'react';
import { Input, Spin } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useDebounce } from 'use-debounce';

const { Search } = Input;

const SearchBar = ({ onSearch, loading = false, placeholder = 'بحث...', style }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearch] = useDebounce(searchTerm, 300);

  useEffect(() => {
    if (onSearch) {
      onSearch(debouncedSearch);
    }
  }, [debouncedSearch, onSearch]);

  return (
    <Spin spinning={loading}>
      <Search
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        allowClear
        // size="small"
        style={{ width: 220, ...style }}
        enterButton={<SearchOutlined />}
      />
    </Spin>
  );
};

export default SearchBar;

